var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState, } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import "./Language.css";
import generateID from "../../../utils/string-utils";
import { Link } from "../Link";
var LanguageList = function (props) {
    var 
    // @ts-ignore
    className = props.className, children = props.children, title = props.title, dropDownOption = props.dropDownOption, label = props.label, id = props.id, _a = props.megaMenu, megaMenu = _a === void 0 ? false : _a, 
    // @ts-ignore
    __TYPE = props.__TYPE, to = props.to, as = props.as, remainingProps = __rest(props, ["className", "children", "title", "dropDownOption", "label", "id", "megaMenu", "__TYPE", "to", "as"]);
    var _classNames = classNames(className, __TYPE, "fr-nav__item");
    var _classNames_link = classNames("fr-nav__link", __TYPE);
    var navMenuId = useRef(id || generateID());
    useEffect(function () {
        navMenuId.current = id || generateID();
    }, [id]);
    var _b = useState(0), active = _b[0], setActive = _b[1];
    var _c = useState(false), expand = _c[0], setExpand = _c[1];
    var navList;
    navList = dropDownOption === null || dropDownOption === void 0 ? void 0 : dropDownOption.map(function (menu, i) {
        return (React.createElement("li", { key: i },
            React.createElement("a", { className: _classNames_link, href: menu.route, target: "_self", onClick: function () { return setActive(i); }, "aria-current": active === i ? "page" : undefined }, menu.label)));
    });
    return (React.createElement("li", { className: _classNames }, dropDownOption ? (React.createElement(React.Fragment, null,
        React.createElement("button", { className: "fr-nav__btn fr__lg_btn fr-translate__btn", onClick: function () {
                setExpand(!expand);
            }, "aria-expanded": expand, "aria-controls": navMenuId.current }, dropDownOption[active].value),
        React.createElement("div", { className: expand
                ? "fr-collapse fr-menu fr-collapse--expanded"
                : "fr-collapse fr-menu", id: navMenuId.current },
            React.createElement("ul", { className: "fr-menu__list" }, navList)))) : (React.createElement(Link, __assign({ to: to, as: as, className: _classNames_link }, remainingProps), label || children))));
};
LanguageList.defaultProps = { __TYPE: "LanguageList" };
LanguageList.propTypes = { __TYPE: PropTypes.string };
export default LanguageList;
